import { createContext } from 'react';

import Key from '~interfaces/key';

export interface SelectedKeysContextValue {
	selectedKeys: Key[];
	singleKey: Key | undefined;
	addKey: (key: Key) => void;
	removeKey: (key: Key) => void;
	replaceSelectedKeys: (keys: Key[]) => void;
	updateSingleKey: (key: Key | undefined) => void;
}

const SelectedKeysContext = createContext<SelectedKeysContextValue>({
	selectedKeys: [],
	singleKey: undefined,
	addKey: () => {},
	removeKey: () => {},
	replaceSelectedKeys: () => {},
	updateSingleKey: () => {},
});

export default SelectedKeysContext;
